module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"doc":"课件","msg":"留言","atta":"附件","close":"关闭","sureDel":"确定要删除课件吗？"},"TW":{"doc":"課件","msg":"留言","atta":"附件","close":"關閉","sureDel":"確定要删除課件嗎？"},"en":{"doc":"Lesson Docs","msg":"Message","atta":"Attachment","close":"Close","sureDel":"Are you sure you want to delete the courseware?"}}')
  delete Component.options._Ctor
}
